<template>
  <div class="complectation-element-manage flex flex-col">
    <div class="title flex justify-between items-center">
      <span>
        <slot name="header"></slot>
      </span>
      <button @click="$emit('close')">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="body flex-1 overflow-x-hidden">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "ElementsEngraving",
  props: {},
  computed: {},
};
</script>
<style scoped>
.title {
  margin-bottom: 50px;
}
.body {
  padding: 0 15px;
}
</style>
